// extracted by mini-css-extract-plugin
export default {"navBtn":"PaginationNavButton_navBtn__oVke7","navBtnText":"PaginationNavButton_navBtnText__i+wEB"};